<template>
  <div class="reports">
    <header-view />
    <div :class="{'loaded': dataLoaded }">
      <div class="loader">Loading...</div>
      <problem-filters :totals="totals" :filters="filters" :selectedFilters="selectedFilters" @filtersChanged="filtersChanged" />
      <div :class="{'viewContainer': true, 'chart': viewMode === 'chart', 'mapView': viewMode === 'map'}">
        <div id="chart"></div>
        <div id="mapView" >Mapview</div>
        <!-- <button class="toggle btn" @click="toggleView">
          <span>Map</span>
          <span class="chart">Chart</span>
        </button> -->
        <div class="settings">
          <div class="view setting">
            <h4>Layout</h4>
            <div class="field">
              <label>
                <input type="radio" name="view" value="map" @change="viewchanged" :checked="viewMode === 'map'"> 
                <span>Map</span>
              </label>
            </div>
            <div class="field">
              <label>
                <input type="radio" name="view" value="chart" @change="viewchanged" :checked="viewMode === 'chart'">  
                <span>Chart</span>
              </label>
            </div>
          </div>
          <div v-if="viewMode === 'map'" class="divisions setting">
            <h4>Divisions</h4>
            <div class="field">
              <label>
                <input type="radio" name="divisions" value="neighborhoods" @change="divisionsChanged" :checked="divisionsMode === 'neighborhoods'">  
                <span>Neighborhoods</span>
              </label>
            </div>
            <div class="field">
              <label>
                <input type="radio" name="divisions" value="councilman" @change="divisionsChanged" :checked="divisionsMode === 'councilman'">  
                <span>Councilman</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="schools">
      <school-view v-for="school in schools" v-bind:key="school['.school_id']" :school="school" @editProblem="editProblem" />
    </div>
    <!--  :edit="edit" -->
    <problem-editor-modal :profile="profile" :fulledit="profile.role == 'Admin'" :problem="problemToEdit" @cancel="problemEditorCanceled" @created="problemEditorCreated" @updated="problemEditorUpdated" />
  </div>
</template>
<script>
  import database from '@/api/database.js'
  import webapi from '@/api/webapi.js'
  import SchoolView from '@/components/SchoolView.vue'
  import HeaderView from '@/components/HeaderView.vue'
  import ProblemFilters from '@/components/ProblemFilters.vue'
  import ProblemEditorModal from '@/components/ProblemEditorModal.vue'
  import { groupBy } from '@/utils'
  import { compareAsc } from 'date-fns'
  import c3 from 'c3'
  import * as d3 from 'd3'
  import L from 'leaflet'
  require('leaflet.snogylop')

  export default {
    name: 'home',
    components: {
      SchoolView, HeaderView, ProblemFilters, ProblemEditorModal
    },
    data () {
      return {
        dataLoaded: false,
        viewMode: 'map',
        divisionsMode: 'neighborhoods',
        filters: [],
        selectedFilters: {},
        sorts: [
          {'label': 'Last Updated', 'key': 'lastUpdated'}
        ],
        sortKey: 'lastUpdated',
        totals: {
          problems: 0,
          rooms: 0,
          schools: 0,
          people: 0
        },
        problems: [],
        problemToEdit: undefined,
        problemColors: {
          'Water / Steam Leaks': 'rgb(31, 119, 180)',
          'Flaking Paint': 'rgb(255, 127, 14)',
          'Indoor Air Quality': 'rgb(44, 160, 44)',
          'Mold Growth': 'rgb(214, 39, 40)',
          'Physical Damage': 'rgb(148, 103, 189)',
          'Pest Sightings': 'rgb(140, 86, 75)',
          'Rodent Droppings': 'rgb(227, 119, 194)',
          'Thermal Control': 'rgb(127, 127, 127)',
          'Water Damage': 'rgb(188, 189, 34)',
          'Workplace Illness': 'rgb(23, 190, 207)',
          'Safty Hazards':'rgb(0, 94, 152)',
          'Dirty Conditions': 'rgb(217, 95, 0)',
          'Other': 'rgb(0, 141, 37)'
        },
        mapData: {
          councilman: null,
          neighborhoods: null
        },
        mapDivisonLayer: null,
        mapViewNode: null,
        mapSchoolMarkers: [],
        mapSchoolLabels: [],
        profile: undefined
      }
    },
    beforeCreate () {
      // These need to get loaded before processing problems
      database.getFields().then(fields => {
        this.filters = Object.values(fields)
        Object.keys(fields).forEach(fieldName => {
          this.sorts.push({'label': fields[fieldName].shortLabel, 'key': fieldName})
        })
      }),
      database.getCurrentUserAndProfile().then(userAndProfile => {
        this.profile = userAndProfile.profile
      })
    },
    mounted () {
      webapi.getPhillyHoods().then(response => {
        this.drawTheHoods(response)

        database.EventBus.$on('problem-added-remotely', this.problemAddedRemotely)
        database.EventBus.$on('problem-modified-remotely', this.problemModifiedRemotely)
        database.EventBus.$on('problem-removed-remotely', this.problemRemovedRemotely)
        
        database.getProblems().then(allProblems => {
          const problems = allProblems.filter(p => p.status.value > -1)
          this.dataLoaded = true
          this.totals = database.calculateTotals(problems)
          this.problems = problems.map(problem => {
            problem.schoolVal = problem.school.value
            problem.problemVal = problem.problemType.value
            return problem
          })
          this.drawChart()
          this.dropSchools()
        })
      })
    },
    computed: {
      schools () {
        if (this.problems.length === 0) {
          return []
        }
        const problemsBySchool = groupBy(this.problems, 'schoolVal')
        const newSchools = []
        Object.keys(problemsBySchool).forEach(key => {
          newSchools.push({
            school_id: key,
            problems: problemsBySchool[key],
            abbreviated_name: problemsBySchool[key][0].school.shortLabel
          })
        })
        return newSchools.sort((a, b) => { return a.abbreviated_name.localeCompare(b.abbreviated_name) })
      }
    },
    methods: {
      problemAddedRemotely (problem, problemId) {
        problem.schoolVal = problem.school.value
        problem.problemVal = problem.problemType.value
        if (database.problemPassesFilters(this.selectedFilters, problem)) {
          this.problems.unshift(problem)
        }
      },
      problemModifiedRemotely (problem, problemId) {
        problem.schoolVal = problem.school.value
        problem.problemVal = problem.problemType.value
        if (database.problemPassesFilters(this.selectedFilters, problem)) {
          const index = this.problems.findIndex(p => p.id === problemId)
          if (index > -1) {
            this.problems.splice(index,1,problem)
            this.sortKey = 'lastUpdated'
          } else {
            this.problems.unshift(problem)
          }
        } else {
          this.problems.splice(this.problems.findIndex(p => p.id === problemId),1)
        }
      },
      problemRemovedRemotely (problemId) {
        const index = this.problems.findIndex(p => p.id === problemId)
        if (index > -1) {
          this.problems.splice(index,1)
        }
      },
      viewchanged (e) {
        this.viewMode = e.target.value
        if (e.target.value === 'chart') {
          this.tempChart.flush()
        }
      },
      divisionsChanged (e) {
        this.divisionsMode = e.target.value
        this.updateDivisions(e.target.value)
      },
      filtersChanged () {
        database.queryProblems(this.selectedFilters).then(problems => {
          this.problems = problems.map(p => {
            p.schoolVal = p.school.value
            p.problemVal = p.problemType.value
            return p
          })
          this.drawChart()
          this.dropSchools()
          this.totals = database.calculateTotals(problems)
        }).catch(noSelectedFilters => {})
      },
      cleanUpData (data) {
        const clean = []
        const problemNames = this.filters.filter(f => f.name === 'problemType')[0].values.map(f => f.shortLabel)
        const problemValues = this.filters.filter(f => f.name === 'problemType')[0].values.map(f => f.value)
        const problems = {}
        const x = ['x']
        this.schools.forEach((school) => {
          const schoolProblems = groupBy(school.problems, 'problemVal')
          x.push(school.abbreviated_name)
          problemValues.forEach((key, index) => {
            problems[problemNames[index]] = problems[problemNames[index]] || []
            if (schoolProblems[key]) {
              problems[problemNames[index]].push(schoolProblems[key].length)
            } else {
              problems[problemNames[index]].push(null)
            }
          })
        })
        clean.push(x)
        problemNames.forEach(name => {
          clean.push([name, ...problems[name]])
        })
        return clean
      },
      drawChart () {
        if (this.tempChart) {
          this.updateChart(this.problems)
          return
        }
        const chartData = this.cleanUpData(this.problems)
        const problemNames = this.filters.filter(f => f.name === 'problemType')[0].values.map(f => f.shortLabel)
        /*
          TODO: figure this out from data
                add to y axis
              max: 16,
              tick:  values: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
        */
        this.tempChart = c3.generate({
          'bindto': '#chart',
          'data': {
            x: 'x',
            type: 'bar',
            'columns': chartData,
            colors: this.problemColors,
            groups: [problemNames],
            onclick: (d) => {
              this.scrollToSchool(this.schools.filter(school => school.abbreviated_name === this.tempChart.categories()[d.x])[0].school_id)
            }
          },
          tooltip: {
            show: true
          },
          'axis': {
            'rotated': true,
            'x': {
              type: 'category',
              width: 200,
              tick: {
                multiline: false
              }
            },
            'y': {
              tick: {
                format: function (d) {
                    return (parseInt(d) == d) ? d : null;
                }
              }
            }
          },
          grid: {
            y: {
              show: true,
            }
          }
        })
        d3.selectAll('.tick')
        .on('click', (value, index) => {
          this.scrollToSchool(this.schools.filter(school => school.abbreviated_name === this.tempChart.categories()[value])[0].school_id)
        })
      },
      updateChart (data) {
        // todo
        this.tempChart.load({
          columns: this.cleanUpData(data),
          unload: []
        })
      },
      drawTheHoods (data) {
        this.mapData.neighborhoods = data.hoods
        this.mapData.councilman = data.council
        const bounds = new L.LatLngBounds(new L.LatLng(40.1391, -75.2815), new L.LatLng(39.8622, -74.9520))
        this.mapViewNode = L.map('mapView', {
          center: bounds.getCenter(),
          zoom: 12 ,
          maxBounds: bounds,
          maxBoundsViscosity: 0.75
        }) //.setView([39.999, -75.140], 12)
        L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}{r}.png?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 16,
          minZoom: 11,
          id: 'mapbox.light',
          accessToken: 'pk.eyJ1IjoiY3phcGF0YSIsImEiOiJjanJwazkwYXExZjR3NDRtdGEyaDAzbHM1In0.Qh3IlFkiqIH6RdD-eTMDEA'
        }).addTo(this.mapViewNode)
        L.geoJSON(data.limits, {
          invert: true,
          stroke: false,
          fillColor: 'white',
          fillOpacity: 0.9
        }).addTo(this.mapViewNode)
        this.mapDivisonLayer = L.geoJSON(data.hoods, {
          weight: 1,
          color: '#004C54',
          fillOpacity: 0.0
        })
        this.mapDivisonLayer.addTo(this.mapViewNode)
        this.mapViewNode.scrollWheelZoom.disable()
        this.mapViewNode.on('zoomend', this.doTooltipsForZoom)
      },
      updateDivisions (divisions) {
        if (this.mapData[divisions] === undefined || !this.mapData[divisions]) {
          return
        }
        if (this.mapDivisonLayer) {
          this.mapDivisonLayer.remove()
          this.mapDivisonLayer = null
        }
        this.mapDivisonLayer = L.geoJSON(this.mapData[divisions], {
          weight: 1,
          color: '#004C54',
          fillOpacity: 0.0
        })
        this.mapDivisonLayer.addTo(this.mapViewNode)        
      },
      doTooltipsForZoom () {
        if (this.mapViewNode.getZoom() > 12 && this.mapSchoolLabels.length === 0) {
          this.mapSchoolMarkers.forEach(layer => {
            var text = L.divIcon({
              html: '<span>' + layer.options.schoolName + '</span>',
              className: 'pft-city-text'
            })
            var m = L.marker(layer.getLatLng(), {icon: text ,interactive: false}).addTo(this.mapViewNode)
            this.mapSchoolLabels.push(m)
          }) 
        } else if (this.mapViewNode.getZoom() <= 12) {
          this.mapSchoolLabels.forEach(layer => {
            layer.remove()
          })
          this.mapSchoolLabels = []
        }
      },
      dropSchools () {
        this.mapSchoolMarkers.forEach(layer => {
          layer.remove()
        })
        this.mapSchoolMarkers = []
        this.schools.forEach(school => {
          const probs = school.problems
          const probWithCoordinates = probs.find(prob => prob.coordinates)
          // TODO get coordinates from school object
          // console.log('🏠 311', probWithCoordinates)
          if (!probWithCoordinates) {
            return
          }
          const coords = probWithCoordinates.coordinates
          const schoolProblems = groupBy(probs, 'problemVal')
          var circle = L.circle(coords, {
            color: '#e72b4a',
            fillColor: '#ff717e',
            weight: 1,
            radius: Math.sqrt(probs.length) * 300,
            schoolId: school.school_id,
            schoolName: school.abbreviated_name
          }).addTo(this.mapViewNode)
          circle.on({
            'mouseover': (e) => {
              const problems = []
              var popContent = '<table class="c3-tooltip"><tbody><tr><th colspan="2">' + school.abbreviated_name + '</th></tr>'
              Object.keys(schoolProblems).forEach(id => {
                const problemName = schoolProblems[id][0].problemType.shortLabel
                popContent += '<tr class="c3-tooltip-name"><td class="name"><span style="background-color:' + this.problemColors[problemName] + '"></span>' + problemName + '</td><td class="value">' + schoolProblems[id].length + '</td></tr>'
              })
              popContent += '</tbody></table>'
              L.popup({
                'className': 'pft-pop'
              })
              .setLatLng(coords)
              .setContent(popContent)
              .openOn(this.mapViewNode)
            },
            'mouseout': (e) => {
              this.mapViewNode.closePopup()
            },
            'click': (e) => {
              if (e.sourceTarget.options && e.sourceTarget.options.schoolId) {
                this.scrollToSchool(e.sourceTarget.options.schoolId)
              }
            }
          })
          this.mapSchoolMarkers.push(circle)
        })
      },
      scrollToSchool (id) {
        var element = document.getElementById('school-' + id)
        if (element) {
          var top = element.offsetTop
          window.scrollTo(0, top - 80)
        }
      },
      editProblem (problem) {
        this.problemToEdit = JSON.parse(JSON.stringify(problem))
        this.$modal.show('problem-container')
      },
      problemEditorCanceled () {
        this.$modal.hide('problem-container')
        this.problemToEdit = undefined
      },
      problemEditorCreated (createdProblem) {
        this.problems.push(createdProblem)
        this.problemEditorCanceled()
      },
      problemEditorUpdated (updatedProblem) {
        this.problems.splice(this.problems.findIndex(p => p.id === updatedProblem.id),1,updatedProblem)
        this.problemEditorCanceled()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reports {
  padding:60px 0 0 0;
  position: relative;
}
.viewContainer {
  margin-top: 13px;
  height: 800px;
  position: relative;
}
/* .viewContainer .toggle {
  position: absolute;
  top: 15px;
  right: 25px;
  cursor: pointer;
  font-weight: bold;
  color: white;
  background: #4b663c;
  padding: 5px 10px;
  z-index: 10;
} */
.viewContainer .settings {
  position: absolute;
  top: 15px;
  right: 25px;
  z-index: 10;
}
.settings .setting {
  margin-bottom: 15px;
}
.settings .setting h4 {
  text-align: right;
}
.settings .setting .field {
  margin-bottom: 5px;
}
.settings .setting label {
  display: flex;
  flex-direction: row-reverse;
}
.settings .setting span {
  display: inline-block;
  padding: 2px 10px 0;
}
.viewContainer.mapView #mapView {
  visibility: visible;
}
.viewContainer.mapView #chart {
  visibility: hidden;
}
.viewContainer.chart #mapView {
  visibility: hidden;
}
.viewContainer.chart #chart {
  visibility: visible;
}
#mapView,
#chart {
  height: 800px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.loaded #mapView,
.loaded #chart {
  opacity: 1
}
.loaded .loader {
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
h1 {
  margin: 0 0 10px;
}
h4 {
  margin: 0 0 10px;
}
</style>